export default "__VITE_ASSET__DJzl36gJ__"